import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Box, ButtonBase, Slide, useTheme, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import MSelectLabel from '../../../../../components/global/Modals/MSelectLabel';
import SpOrderDetails from '../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails';
import { getShipperColorSettingsByType } from "../../../../../components/Streams/StreamShipperSettings";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { DropdownBase, ShDropdownQuery } from "../../../../../components/theme/dropdowns/Dropdown";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import ShPayloadToggle from "../../../../../components/theme/ShPayloadToggle";
import Heading from "../../../../../components/theme/text/Heading";
import Subheading from "../../../../../components/theme/text/Subheading";
import Text from "../../../../../components/theme/text/Text";
import { useGetCarriersSelectQuery } from "../../../../../newapi/carrier/carrierSlice";
import { useFinalizeOrderMutation, useRestartOrderEcheckMutation } from "../../../../../newapi/global/echeckSlice";
import { useEditOrderCarrierMutation } from "../../../../../newapi/order/ordersSlice";
import { useGetShippersSelectWithProfilesQuery } from "../../../../../newapi/shipper/shipperSlice";
import { selectUserPermission } from '../../../../../newapi/user/authentication/authSlice';
import { ReactComponent as BolLogo } from '../../../../../styles/svg/bol.svg';
import { ReactComponent as CirroLogo } from '../../../../../styles/svg/cirro.svg';
import { ReactComponent as DhlLogo } from '../../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../../styles/svg/dpd.svg';
import { ReactComponent as HstLogo } from '../../../../../styles/svg/hst.svg';
import { ReactComponent as PostNLLogo } from '../../../../../styles/svg/postnl.svg';
import { tokens } from "../../../../../theme";
import { hexToRgb } from '../../../../../utils/colorConverters';
import { UserPrivileges } from '../../../../../utils/permissions';
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import { filterShipperProfilesByDeliveryCountry, getOrderDeliveryCountry, purgeEmptyCarriersAndBundles } from '../../helper';
import EditCarrierPreviousOrderDropdownItem from "../EditCarrierPreviousOrderDropdownItem";
import Truck from "../truck/Truck";
import { CarrierViewReadOnly } from './CarrierView';

const PreviousOrderEchecked = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
        const [spLoading, setSpLoading] = useState(false);
    const [orderOpen, setOrderOpen] = useState(false);
    const [orderId, setOrderId] = useState(null);

    const openOrder = () => {
        // Only update state if the orderId has actually changed
        //if(!spLoading) {
            setOrderId(props.previousOrder.order?.id);
            setSpLoading(true);
            setOrderOpen(true);
        //}
    }

    const [confirmNewFromOldOpen, setConfirmNewFromOldOpen] = useState(false);
    const [confirmRestartEcheckOpen, setConfirmRestartEcheckOpen] = useState(false);
    const [editCarrierModalOpen, setEditCarrierModalOpen] = useState(false);
    const [labelsModal, setLabelsModal] = useState({
        open: false,
        labels: [],
        type: ''
    });

    const ShipperLogoMap = {
        postnl: PostNLLogo,
        dhl: DhlLogo,
        dhlgermany: DhlGermanyLogo,
        dpd: DpdLogo,
        bol: BolLogo,
        cirro:CirroLogo,
        hst: HstLogo
      };

    const renderShipperLogo = (shipperType) => {
        // Get the logo component based on shipper type
        const LogoComponent = ShipperLogoMap[shipperType];

        // Render the logo component if it exists, or null otherwise
        return LogoComponent ? <LogoComponent className={shipperType} /> : null;

    };

    const [carrier,setCarrier] = useState({
        id: -1,
        title: t("no_carrier_advice")
    });
    const [shipper, setShipper] = useState({
        id:-1,
        name:t("no_selection"),
    })
     const [shipperProfile, setShipperProfile] = useState({
        id:-1,
        name:t("no_selection"),
    })


    useEffect(() => {
        if(props.previousOrder.order.suggestedCarrier) {
            setCarrier(props.previousOrder.order.suggestedCarrier)
        }
        if(props.previousOrder.shipper){
            setShipper(props.previousOrder.shipper);
        }
        if(props.previousOrder.shipperProfile){
            setShipperProfile(props.previousOrder.shipperProfile);
        }
    }, [props.previousOrder])

    // Shippers + profiles of the previous order's own warehouse
    const { data: shippers } = useGetShippersSelectWithProfilesQuery({warehouseId: props.previousOrder?.order?.warehouseId, includeBol: true},
        {
            skip: !props.previousOrder?.order
        }
    );

    const selectedOrderSelectNewShipper = (selected) => {
        var shipper = shippers.filter(shipper => shipper.type !== 'bol' || props.previousOrder?.order?.webshopcredentials?.webshop_type === 'bol')[selected];
        setShipper(shipper);
        setShipperProfile({
            id:-1,
            name:t("no_selection"),
        });
    }
    const selectedOrderSelectNewShipperProfile = (selected) => {
        const availableProfiles = filterShipperProfilesByDeliveryCountry(shipper?.shipperProfiles, getOrderDeliveryCountry(props.previousOrder?.order));
        var shipperProfile = availableProfiles[selected];
        setShipperProfile(shipperProfile);
    }
    
    const canEditCarrier = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRODUCT_MANAGE])
    ) && !(props.previousOrder?.order?.amountOfProducts === 1 && props.previousOrder?.order?.orderlines[0]?.product?.carrierId > 0 );

    const [finalizeResponse, {isLoading: finalizeLoading,isFetching:finalizeFetching}] = useFinalizeOrderMutation();

    const [editCarrierResponse,{isLoading:carrierEditLoading}] = useEditOrderCarrierMutation();

    const [shippingErrors,setShippingErrors] = useState([]);
    const [shippingPayload, setShippingPayload] = useState(null);

    const finalize = async () => {
        if(props.carrierMandatory){
            if(props.carriers[props.carriers?.length - 1]?.carrierId === null){
                showToastMessage("warning", "Er is geen drager gekozen. Selecteer of scan een drager om af te ronden.");
                return;
            }
        }
        try {
            setShippingErrors([]);
            setShippingPayload(null);
            const response = await finalizeResponse({
                "order": props.previousOrder.order,
                "carriers": purgeEmptyCarriersAndBundles(props.previousOrder.carriers),
                "shipper": shipper?.id ?? props.previousOrder.shipper.id,
                "shipperProfile": shipperProfile?.id ?? props.previousOrder.shipperProfile.id,
                "workspace": props.previousOrder.workspace,
                "fromPreviousOrder": true
            }).unwrap();

            if(response.success){
                if(response.openFiles){
                   if (response.labelContent?.length > 1) {
                        // If multiple labels, open modal with buttons
                        setLabelsModal({
                            open: true,
                            labels: response.labelContent,
                            type: response.labelType
                        });
                    } else if (response.labelContent?.length === 1) {
                        const content = response.labelContent[0];
                        let url = "";
                        if(response.labelType === 'pdf'){
                            const decodedData = atob(content);
                            const arrayBuffer = new ArrayBuffer(decodedData.length);
                            const uint8Array = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < decodedData.length; i++) {
                                uint8Array[i] = decodedData.charCodeAt(i);
                            }
                            const blob = new Blob([uint8Array], { type: 'application/pdf' });
                            url = URL.createObjectURL(blob);
                        } else if(response.labelType === 'link'){
                            url = content;
                        }
                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
                        if (newWindow) {
                            setTimeout(() => {
                                window.URL.revokeObjectURL(url);
                            }, 500);
                        } else {
                            window.URL.revokeObjectURL(url);
                        }
                    }
                }


            } else {
            
                showToastMessage("error", response.message);
            }
        } catch (error) {
            setShippingErrors(error.data?.errors);
            setShippingPayload(error?.data?.payload ?? null);
            showToastMessage("error", error.data?.error);
        }
    }

    const editCarrier = async () => {
        if(carrierEditLoading) return;
        try{
            const resp = await editCarrierResponse({
                orderId: props.previousOrder.order.id,
                suggestedCarrierId:carrier.id
            }).unwrap();

            showToastMessageUpdateRequest(t,resp);
        }
        catch (error) {
            showToastMessageRequestError(t("edit_failed"), t, error);
        }
    }

    const confirmNewFromOldModal = {
        open: confirmNewFromOldOpen,
        setOpen: setConfirmNewFromOldOpen,
        confirm: finalize
    }

    const [restartOrderEcheck] = useRestartOrderEcheckMutation();

    // Bol VVB: cancel all shipments and restart the e-check with the products pre-filled in the first carrier
    const restartEcheck = async () => {
        try {
            const orderId = props.previousOrder.order.id;
            const response = await restartOrderEcheck(orderId).unwrap();
            await props.onRestartEcheck(orderId, response.carrier);
        } catch (error) {
            showToastMessage("error", error.data?.error ?? error.data?.message);
        }
    }

    const confirmRestartEcheckModal = {
        open: confirmRestartEcheckOpen,
        setOpen: setConfirmRestartEcheckOpen,
        confirm: restartEcheck
    }

    const confirmEditCarrier = {
        open: editCarrierModalOpen,
        setOpen: setEditCarrierModalOpen,
        confirm: editCarrier
    }
    
    return (

        <Box
            sx={{
                flex:1,
                flexDirection: "column",
                display:"flex",
                p:2,
                borderRadius:4,
                position:'relative',
                // borderTopLeftRadius:16,
                // borderTopRightRadius:16,
                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                overflow:'auto',
            }}
        >
            <Heading sx={{mb:3}}>
                {t("processed_order")}
            </Heading>

            <Box
                sx={{
                    display:"flex"
                }}
            >
                <Subheading>{props.previousOrder.totalAmount}</Subheading>&nbsp;
                <Subheading light>{props.previousOrder.totalAmount > 1 ? t("products") : t("product")} </Subheading>&nbsp;
                <Subheading semibold variant="purple">{t("processed")}</Subheading>&nbsp;
                <Subheading light>in</Subheading>&nbsp;
                <Subheading>{props.previousOrder.carriers?.length}</Subheading>&nbsp;
                <Subheading light>{t("carriers")}</Subheading>
            </Box>
            <Box
                sx={{
                    mt:2,
                    display:'flex',
                    alignItems:"flex-start",
                    gap:3,
                }}
            >
                {/* {console.log(props.previousOrder)} */}
                <CarrierViewReadOnly
                    readOnly
                    hasPickingslip={props.previousOrder?.hasPickingslip}
                    shipmentIds={props.previousOrder?.shipmentIds}
                    carriers={props.previousOrder?.carriers}
                    invoiceProducts={props.previousOrder?.invoiceProducts}
                />
              

                <Box
                    sx={{
                        minHeight:120,
                        // height:50,
                        position:'sticky',
                        top:0,
                        borderRadius:4,
                        p:1.5,
                        flex:1,
                        boxShadow:`0px 2px 4px ${getShipperColorSettingsByType(shipper?.type).streamrulehover}`,
                        border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}`,
                        // background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                        background: getShipperColorSettingsByType(shipper?.type).background,
                        transition: 'background-color 0.5s',
                    }}
                >
                    {props.previousOrder.order.isB2B &&
                        <Box
                            sx={{
                                mx:1.5,
                                mb:1,
                                mt:1.5,
                                fontSize:16,
                                fontFamily:"Roboto, sans-serif",
                                fontWeight:700,
                                height:32,
                                borderRadius:4,
                                textAlign:"center",
                                lineHeight:"32px",
                                background:getShipperColorSettingsByType(shipper?.type).base,
                                color:getShipperColorSettingsByType(shipper?.type).background,
                            }}
                        >
                            {t("b2b_order")}
                        </Box>
                    }
                    <Box
                        sx={{
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:'center',
                        }}
                    >

                        <Box
                            sx={{
                                pl:1.5,
                                pt:1.5,
                            }}
                        >
                            <Subheading
                                color={
                                    tokens("white").txt["primary"]
                                }
                            >
                                <span style={{cursor: "pointer"}} onClick={() => openOrder()}>
                                    {props.previousOrder.order?.barcode}
                                    <Box sx={{display:"inline-block", scale: "0.7"}}>
                                        <OpenInNewOutlinedIcon/>
                                    </Box>
                                </span>
                                <br/>
                                {props.previousOrder.order?.deliveryName}
                            </Subheading>
                            
                        </Box>

                        <Box
                            sx={{
                                mt:1.5,
                                mr:1.5,
                                mb:1,
                                height:40,
                                display:"flex",
                                alignItems:'center',
                                px:2,
                                pl:0.5,
                                gap:1.5,
                                borderRadius:5,
                                background:getShipperColorSettingsByType(shipper?.type).background,
                                color: getShipperColorSettingsByType(shipper?.type).base,
                                fontWeight:"bold",
                                border: `1px solid ${getShipperColorSettingsByType(shipper?.type).base}`,
                                "& .postnl" : {
                                    width:24,
                                    height:24,
                                },
                
                                "& .dpd" : {
                                    width:24,
                                    height:24,
                                },
                                "& .dhl" : {
                                    width:24,
                                    height:24,
                                },
                                "& .dhlgermany" : {
                                    width:24,
                                    height:24,
                                },
                                "& .bol" : {
                                    width:32,
                                    // width:24,
                                    height:16,
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    height:32,
                                    width:32,
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    background:getShipperColorSettingsByType(shipper?.type).streamrule,
                                    fill:"white",
                                    "& svg" : {
                                        // fill:"white",
                                    },
                                    "& svg *" : {
                                        // fill:"white",
                                    }
                                }}

                            >
                                {renderShipperLogo(shipper.type)}
                            </Box>
                            {props.previousOrder.shipper?.name}
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            p:1.5,
                            mb:1,
                        }}
                    >

                        <Text
                            color={
                                tokens("white").txt["primary"]
                            }
                        >
                            {props.previousOrder.order.shippingAddress?.addressLine1}
                        </Text>
                        <br/>

                        
                        <Text
                            color={
                                tokens("white").txt["primary"]
                            }
                        >
                            {props.previousOrder.order.shippingAddress?.postalCode}, {props.previousOrder.order.shippingAddress?.city}
                        </Text>
                        <br/>
                        
                        <Text
                            color={
                                tokens("white").txt["primary"]
                            }
                        >
                            {props.previousOrder.order.shippingAddress?.state}, {props.previousOrder.order.shippingAddress?.country}
                        </Text>
                        <br/>
                    </Box>
                    <Box
                        sx={{
                            background:getShipperColorSettingsByType(shipper?.type).streamrule,
                            borderRadius:3,
                            p:1.5,
                        }}
                    >
                        

                        {carrier && carrier.id > 0 ?
                            (() => {
                                const parsed = carrier.color ? JSON.parse(carrier.color) : null;
                                let bg = getShipperColorSettingsByType(shipper?.type).streamrulehover;
                                if(parsed && parsed.hex) {
                                    let temp = hexToRgb(parsed.hex);
                                    bg = `rgb(${temp})`;

                                } 
                                
                                return (

                                    <Box
                                        sx={{
                                            display:"flex",
                                            alignItems:"center",
                                            borderRadius:7,
                                            height:40,
                                            px:0.5,
                                            // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                            // background:`rgb(${color?.[0]}, ${color?.[1]}, ${color?.[2]})`,
                                            // background: `linear-gradient(rgba(${rgb?.[0] ?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1), rgba(${rgb?.[0]?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1)), ${theme.palette.mode === "dark" ? "black" : "white"}`, /* Solid white background */
                                            background:bg,
                                            "@media screen and (max-width: 566px)" : {
                                                // px:3,
                                            }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                height:32,
                                                px:1.5,
                                                // background:'orange',
                                                lineHeight:"32px",
                                                borderRadius:4,
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                                border:`1px solid ${colors.grey[100]}`,
                                                fontSize:14,
                                                fontWeight:500,
                                            }}
                                        >
                                            {t("carrier_advice")}
                                        </Box>
                                        
                                        <Box
                                            sx={{
                                                ml:0.5,
                                                lineHeight:"32px",
                                                textAlign:"center",
                                                // width:100,
                                                px:2,
                                                height:32,
                                                borderRadius:4,
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                fontSize:14,
                                                fontWeight:700,
                                                "@media screen and (max-width: 566px)" : {
                                                    flex:1,
                                                }
                                            }}
                                        >
                                            {carrier.name}
                                        </Box>

                                        {canEditCarrier &&
                                            <>
                                                <ShDropdownQuery
                                                    name="name"
                                                    onChange={(selected,object) => {
                                                        setCarrier(object);
                                                    }}
                                                    valueKey={"id"}
                                                    dataKey={null}
                                                    shComponent={<EditCarrierPreviousOrderDropdownItem/>}
                                                    selected={carrier?.id ?? -1}
                                                    // selected={-1}
                                                    content={useGetCarriersSelectQuery}
                                                    closeOnSelection
                                                >
                                                    {({anchorEl,onClick}) => (
                                                        <ButtonBase
                                                            onClick={onClick}
                                                            sx={{
                                                                ml:"auto",
                                                                width:32,
                                                                height:32,
                                                                borderRadius:5,
                                                                // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                                // background:getShipperColorSettingsByType(shipper?.type).base,
                                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                                display:"flex",
                                                                alignItems:'center',
                                                                px:0.5,
                                                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                            
                                                            }}
                                                        >
                                                            <EditOutlinedIcon fontSize="small"/>
                                                        </ButtonBase>
                                                    )}
                                                </ShDropdownQuery>

                                                <ButtonBase
                                                    onClick={() => confirmEditCarrier.setOpen(true)}
                                                    sx={{
                                                        ml:0.5,
                                                        // width:32,
                                                        px:2,
                                                        height:32,
                                                        borderRadius:5,
                                                        // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                        // background:getShipperColorSettingsByType(shipper?.type).base,
                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                        display:"flex",
                                                        alignItems:'center',
                                                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                        fontFamily:"Roboto, sans-serif",
                                                        fontWeight:500,
                                                    }}
                                                >
                                                    {t("save")}
                                                </ButtonBase>
                                            </>
                                        }

                                    </Box>
                                )
                            })()
                        : 
                            <Box
                                sx={{
                                    display:"flex",
                                    alignItems:'center',
                                    height:40,
                                    background:getShipperColorSettingsByType(shipper?.type).streamrulehover,
                                    border:`1px solid ${getShipperColorSettingsByType(shipper?.type).base}`,
                                    boxShadow:`0px 2px 4px ${getShipperColorSettingsByType(shipper?.type).base}`,
                                    px:0.5,
                                    borderRadius:5,
                                }}
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            background:getShipperColorSettingsByType(shipper?.type).base,
                                            color:"white",
                                            px:1.5,
                                            height:32,
                                            lineHeight:"32px",
                                            borderRadius:4,
                                            mr:1.5,
                                        }}
                                    >
                                        <Text bold color={"white"}>{t("carrier_advice")}</Text>
                                    </Box>
                                    <Text color={getShipperColorSettingsByType(shipper?.type).base} bold>
                                        {carrier && carrier.id > 0 ? 
                                            carrier.name : 
                                            t("no_carrier_advice")
                                        }
                                    </Text>
                                </Box>


                                {canEditCarrier &&
                                    <>
                                        <ShDropdownQuery
                                            name="name"
                                            onChange={(selected,object) => {
                                                setCarrier(object);
                                            }}
                                            valueKey={"id"}
                                            dataKey={null}
                                            shComponent={<EditCarrierPreviousOrderDropdownItem/>}
                                            selected={carrier?.id ?? -1}
                                            // selected={-1}
                                            content={useGetCarriersSelectQuery}
                                            closeOnSelection
                                        >
                                            {({anchorEl,onClick}) => (
                                                <ButtonBase
                                                    onClick={onClick}
                                                    sx={{
                                                        ml:"auto",
                                                        width:32,
                                                        height:32,
                                                        borderRadius:5,
                                                        // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                        // background:getShipperColorSettingsByType(shipper?.type).base,
                                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                        display:"flex",
                                                        alignItems:'center',
                                                        px:0.5,
                                                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                    
                                                    }}
                                                >
                                                    <EditOutlinedIcon fontSize="small"/>
                                                </ButtonBase>
                                            )}
                                        </ShDropdownQuery>

                                        <ButtonBase
                                            // onClick={onClick}
                                            onClick={() => confirmEditCarrier.setOpen(true)}
                                            sx={{
                                                ml:0.5,
                                                // width:32,
                                                px:2,
                                                height:32,
                                                borderRadius:5,
                                                // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[400],
                                                // background:getShipperColorSettingsByType(shipper?.type).base,
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                                display:"flex",
                                                alignItems:'center',
                                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                fontFamily:"Roboto, sans-serif",
                                                fontWeight:500,
                                            }}
                                        >
                                            {/* <EditOutlinedIcon fontSize="small"/> */}
                                            {t("save")}
                                        </ButtonBase>
                                    </>
                                }
                            </Box>
                        }

                        <Box
                            sx={{
                                mt:2,
                            }}
                        >
                            
                            <Text color={tokens("white").txt["primary"]}  light>{t("shipper")}:</Text>
                            <Box 
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:'space-between',
                                }}
                            >
                                <Text color={getShipperColorSettingsByType(shipper?.type).base} bold>{shipper?.name}</Text>
                                {props.selectedOrder?.deliveryMethod !== "vvb" &&
                                    <ButtonBase
                                        sx={{
                                            ml:2,
                                            width:32,
                                            height:32,
                                            background: getShipperColorSettingsByType(shipper?.type).base,
                                            color:"#fff",
                                            borderRadius:5,
                                        }}
                                    >
                                        <DropdownBase
                                            transformOrigin={{
                                                vertical: "bottom"
                                            }}
                                            anchorOrigin={{
                                                vertical:"top"
                                            }}
                                            displayName={"name"} 
                                            onChange={(selected) => 
                                                {
                                                    selectedOrderSelectNewShipper(selected);
                                                }
                                            }
                                            noSelection={""} //Custom text when nothing is selected
                                            options={shippers?.filter(shipper => shipper.type !== 'bol' || props.previousOrder?.order?.webshopcredentials?.webshop_type === 'bol')}
                                            selected={-1}
                                            closeOnSelection
                                            resetOnSelection
                                        >
                                            <EditOutlinedIcon/>
                                        </DropdownBase>
                                    </ButtonBase>
                                }
                            </Box>
                        
                        </Box>

                        <Box
                            sx={{
                                mt:2,
                            }}
                        >
                            <Text color={tokens("white").txt["primary"]}  light>{t("shipperprofile")}:</Text><br/>
                            <Box
                                sx={{
                                    display:"flex",
                                    justifyContent:'space-between',
                                    alignItems:'center',
                                }}
                            >
                                <Text color={getShipperColorSettingsByType(shipper?.type).base} bold>{shipperProfile?.name}</Text>
                                {props.selectedOrder?.deliveryMethod !== "vvb" &&
                                    <ButtonBase
                                        sx={{
                                            width:32,
                                            height:32,
                                            background:getShipperColorSettingsByType(shipper?.type).base,
                                            color:"#fff",
                                            borderRadius:5,
                                        }}
                                    >
                                        <DropdownBase
                                            transformOrigin={{
                                                vertical: "bottom"
                                            }}
                                            anchorOrigin={{
                                                vertical:"top"
                                            }}
                                            displayName={"name"} 
                                            // onChange={(selected) => props.selectShipperProfile(selected)}
                                            onChange={(selected) => 
                                                {
                                                    selectedOrderSelectNewShipperProfile(selected)
                                                }
                                            }
                                            noSelection={""} //Custom text when nothing is selected
                                            options={filterShipperProfilesByDeliveryCountry(shipper?.shipperProfiles, getOrderDeliveryCountry(props.previousOrder?.order))}
                                            selected={-1}
                                            closeOnSelection
                                            resetOnSelection

                                            searchOptions={{
                                                enabled: true,
                                                placeholder: t("search_shipper_profile"),
                                                allowSelectionOnEnter: true
                                            }}
                                        >
                                            <EditOutlinedIcon/>
                                        </DropdownBase>
                                    </ButtonBase>
                                }
                            </Box>
                        
                        </Box>
                        
                        {/* This is to show what type of bol label was pre selected */}
                        {props.previousOrder.shipper?.type === "bol" && (
                            <Box 
                            sx={{
                                mt:2,
                            }}
                            >
                                <Text color={tokens("white").txt["primary"]}>{t("selected_label")}:</Text><br/>
                                <Box
                                    sx={{
                                        display:"flex",
                                        justifyContent:'space-between',
                                        alignItems:'center',
                                    }}
                                >
                                    <Text color={getShipperColorSettingsByType(props.previousOrder.shipper?.type).base} bold>
                                        {props.previousOrder?.order?.labelData?.labelInfo?.labelDisplayName ?? t("label_to_be_determined")}
                                    </Text>
                                </Box>
                            </Box>
                        )}
                        {shippingErrors && shippingErrors.length > 0 &&
                            <Box 
                                sx={{
                                    mt:3,
                                    width:1,
                                    position:"relative",
                                    background:colors.red[100],
                                    borderRadius:4,
                                    p:2,
                                    pr:8,
                                    display:"flex",
                                    flexDirection:"column",
                                    gap:1,
                                }}
                            >
                                {shippingErrors.map((err,idx) => (
                                    <Text key={"se"+idx} bold variant={"red"}>{err}</Text>
                                ))}
                                <ShPayloadToggle payload={shippingPayload} />
                                <ShCopyButton
                                    styles={{button:{
                                        background:colors.red[100],
                                        color: colors.red[400],
                                        "&:hover" : {
                                            background:colors.red[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'],
                                        }
                                    }}} 
                                    sx={{position:"absolute",top:56,right:16,zIndex:3000}} 
                                    className={"copyel"} 
                                    closeAfter={1500} 
                                    value={shippingErrors.join('\n')}
                                ></ShCopyButton>
                                <IconButton
                                    onClick={() => setShippingErrors([])}
                                    sx={{
                                        position:"absolute",
                                        top:16,
                                        right:16,
                                        zIndex:3000,
                                        background:colors.red[100],
                                        color: colors.red[400],
                                        "&:hover" : {
                                            background:colors.red[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'],
                                        }
                                    }}
                                >
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </Box>
                        }
                        <Box
                            sx={{
                                mt:3,
                                // display:"flex",
                                // justifyContent:"space-between",
                                // alignItems:"center",
                                width:1,
                                mb:1.5,
                            }}
                        >
                            <Shbutton
                                block 
                                className={"group-btn"} 
                                isLoading={finalizeLoading || finalizeFetching} 
                                color={"orange"} 
                                // variant="contained" 
                                onClick={() =>{
                                    // Bol VVB always labels all items, so re-finalizing would duplicate products
                                    if(shipper?.type === "bol"){
                                        if(props.onRestartEcheck){
                                            confirmRestartEcheckModal.setOpen(true);
                                        }else{
                                            showToastMessage("warning", t("bol_new_label_not_possible"));
                                        }
                                        return;
                                    }

                                    confirmNewFromOldModal.setOpen(true);
                                    // createNewLabel();
                                    //  replaceLabel()
                                }}
                                sx={{
                                    color: getShipperColorSettingsByType(shipper?.type).base, 
                                    background: getShipperColorSettingsByType(shipper?.type).background,
                                    border:`1px solid ${getShipperColorSettingsByType(shipper?.type).base}`,
                                }}
                            >
                                {t("new_shipment")}
                            </Shbutton>
                        </Box>
                    </Box>

                </Box>
            </Box>
            <Slide
                direction="up" 
                in={finalizeLoading || finalizeFetching}
            >
                <Box
                    sx={{ 
                        borderRadius:8,
                        background:"#fff",
                        width:1,
                        height:65,
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:'center',
                        px:3,
                        position:'relative',
                        zIndex:1,
                        // left:"50%",
                        // transform:"translateX(-50%)",
                        overflow:'visible',
                        "&:before" : {
                            position:'absolute',
                            content:"''",
                            left:6,
                            right:6,
                            top:6,
                            bottom:6,
                            zIndex:-1,
                            borderRadius:12,
                            filter:"blur(12px)",
                            background: 'linear-gradient(var(--gradient-angle), #31415f, #0D61FF, #C2D7FF)',
                            animation: 'rotation 5s linear infinite'
                        },
                        "&:after" : {
                            position:'absolute',
                            content:"''",
                            left:0,
                            right:0,
                            top:0,
                            bottom:0,
                            zIndex:-1,
                            borderRadius:12,
                            background:'#fff'
                        }
                    }}
                >
                    <Box width={60} />
                    <Subheading>
                        {t('echeck_processing_order')}
                    </Subheading>
                    <Truck/>
                </Box>
            </Slide>
            <MConfirmation
                title={t("new_shipment")}
                subtitle={t("create_new_shipment")}
                open={confirmNewFromOldModal.open}
                handleClose={() => confirmNewFromOldModal.setOpen(false)}
                confirm={confirmNewFromOldModal.confirm}
            />
            <MConfirmation
                title={t("restart_echeck")}
                subtitle={t("restart_echeck_bol_subtitle")}
                open={confirmRestartEcheckModal.open}
                handleClose={() => confirmRestartEcheckModal.setOpen(false)}
                confirm={confirmRestartEcheckModal.confirm}
            />
            <MConfirmation
                title={t("edit_carrier")}
                subtitle={t("edit_carrier_subtitle")}
                open={confirmEditCarrier.open}
                handleClose={() => confirmEditCarrier.setOpen(false)}
                confirm={confirmEditCarrier.confirm}
            />
            <MSelectLabel
                open={labelsModal.open}
                handleClose={() => setLabelsModal({ open: false, labels: [], type: '' })}
                labels={labelsModal.labels}
                type={labelsModal.type}
            />
            {spLoading && 
                <SpOrderDetails
                    isExtended={orderOpen}
                    setIsExtended={setOrderOpen}
                    orderId={orderId}
                    defaultTab={2}
                    // data={orderData}
                /> 
            }
        </Box>

    );
}

export default PreviousOrderEchecked;